(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .factory('routerSetup', routerSetup);

    routerSetup.$inject = ['$rootScope', '$state', 'routerHelper'];

    /* @ngInject */
    function routerSetup($rootScope, $state, routerHelper) {
        var service = {
            run: run
        };
        return service;

        ////////////////

        function run() {
            routerHelper.configureStates(getStates());

            $rootScope.$on('$stateChangeStart', function() {
                $rootScope.stateLoading = true;
            });

            $rootScope.$on('$stateChangeSuccess', function() {
                $rootScope.stateLoading = false;
            });

            $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error){
                console.log('$stateChangeError', event, toState, toParams, fromState, fromParams, error);
                if(error == 'go to auth') {
                    $state.go('auth');
                } else if(error == 'go to home') {
                    $state.go('project');
                }
            });

        }


        function checkAuthenticate($q, AuthService, UserService) {
            if (!AuthService.isAuthenticated()) {
                return $q.reject('go to auth');
            }
            if(!UserService.getUser()) {
                return UserService.loadUser(AuthService.getUserId())
            }
            return $q.resolve();
        }

        function getStates() {
            var navView = {
                templateUrl: 'templates/nav/navbar.html',
                controller: 'NavController',
                controllerAs: 'vm'
            };

            var profileView = {
                templateUrl: 'templates/layout/profile.html',
                controller: 'ProfileController',
                controllerAs: 'vm',
                resolve: {
                    /* @ngInject */
                    promiseObj: ['$q', 'AuthService', 'UserService', '$ocLazyLoad',
                        function($q, AuthService, UserService, $ocLazyLoad) {
                            return checkAuthenticate($q, AuthService, UserService)
                                .then(function() {
                                    return $ocLazyLoad.load(['flow', 'ngImgCrop']);
                                })
                        }
                    ]
                }
            };

            return [
                {
                    state: 'auth',
                    config: {
                        url: '/login',
                        views: {
                            'main': {
                                templateUrl: 'templates/auth/login.html',
                                controller: 'AuthController',
                                controllerAs: 'vm',
                                resolve: {
                                    /* @ngInject */
                                    authorized: ['$q', 'AuthService', function ($q, AuthService) {
                                        return AuthService.isAuthenticated() ? $q.reject('go to home') : $q.resolve();
                                    }]
                                }
                            }
                        }
                    }
                },
                {
                    state: 'profile',
                    config: {
                        url: '/profile',///{userId:[0-9]{0,2}}?role',
                        views: {
                            'nav': navView,
                            'main': profileView
                        }
                    }
                },
                {
                    state: 'project',
                    config: {
                        url: '/project',
                        views: {
                            'nav': navView,
                            'main': {
                                templateUrl: 'templates/project/project.html',
                                controller: 'ProjectController',
                                controllerAs: 'vm',
                                resolve: {
                                    /* @ngInject */
                                    checkAuthenticate: ['$q', 'AuthService', 'UserService',
                                        function($q, AuthService, UserService) {
                                            return checkAuthenticate($q, AuthService, UserService);
                                        }
                                    ],

                                    /* @ngInject */
                                    loadedManager: ['checkAuthenticate', 'UserService', 'User', function (checkAuthenticate, UserService, User) {
                                        if(UserService.hasUser()) {
                                            return User.get({userId: UserService.getUser()['manager_id']})
                                                .$promise
                                                .then(function(response) {
                                                    response.user.name = UserService.getName(response.user);
                                                    response.user.avatar = UserService.getAvatar(response.user);
                                                    return response.user
                                                });
                                        }
                                        return [];
                                    }],
                                    /* @ngInject */
                                    loadDirectory: ['checkAuthenticate', 'ProjectStatusService', 'UserService', function (checkAuthenticate, ProjectStatusService, UserService) {
                                        if(UserService.hasUser()) {
                                            return ProjectStatusService.load();
                                        }
                                        return [];
                                    }],
                                    /* @ngInject */
                                    filesPerStep: ['AdminStepFile', '_', function(AdminStepFile, _) {
                                        return AdminStepFile.get()
                                            .$promise
                                            .then(function(response) {
                                                return _.groupBy(response.object, 'step_id');
                                            });
                                    }],
                                    /* @ngInject */
                                    loadLibs: ['$ocLazyLoad', function ($ocLazyLoad) {
                                        return $ocLazyLoad.load(['ngSticky', 'slick', 'flow']);
                                    }]
                                }
                            },
                            "contact@project": {
                                templateUrl: 'templates/project/contact.html'
                            },
                            "step@project": {
                                templateUrl: 'templates/project/step.html'
                            },
                            "files@project": {
                                templateUrl: 'templates/project/files.html'
                            },
                            "dialog@project": {
                                templateUrl: 'templates/project/dialog.html',
                                controller: 'ProjectDialogController',
                                controllerAs: 'vm'
                            }
                        }
                    }
                }
            ]
        }
    }

})();

